import React from 'react';
import style from './ChapterSectionPressPlay.module.scss';
import PlaylistButton from '../global/playlist/PlaylistButton';

const PlaylistCoverText = props => (
  <div className={props.isActive}>
    <div
      className={style.storyIntro}
      style={{ pointerEvents: props.isPlaylistOpen ? 'none' : 'auto' }}
    >
      {props.playlist.label && (
        <div className={style.storyLabel}>
          <div className="maskDownLabel">{props.playlist.label}</div>
        </div>
      )}
      <div className={style.storyTitleWrapper}>
        <div
          className={`splitText js-storyTitle ${style.storyTitle}`}
          dangerouslySetInnerHTML={{ __html: props.playlist.title }}
        />
      </div>
    </div>
    <div
      className={`fadeOutWatermark chapter-watermark ${style.storyWatermark}`}
    >
      {props.playlist.watermark}
    </div>
    <div className={`js-storyInstructions ${style.storyInstructions}`}>
      <p className="fadeOut">
        Press and hold <br /> to view the story
      </p>
      <PlaylistButton
        index={props.index}
        handleMouseDown={props.handleMouseDown}
        handleMouseUp={props.handleMouseUp}
        registerProgressBar={props.registerProgressBar}
        disallowScroll={props.disallowScroll}
        allowScroll={props.allowScroll}
      />
    </div>
  </div>
);

export default PlaylistCoverText;



// WEBPACK FOOTER //
// ./src/components/chapter/PlaylistCoverText.js